import { useQuery } from '@tanstack/react-query'
import type { SeasonStats } from '../types'

export const useSeasonStats = (seasonId: number | null) => {
    return useQuery<SeasonStats>({
        queryKey: ['leaderboard', 'season', seasonId, 'stats'],
        queryFn: async () => {
            const res = await fetch(`/api/leaderboard/season/${seasonId}/stats/`)
            return res.json()
        },
        enabled: seasonId !== null,
        retry: false,
    })
}
